
    var riot = require('riot')
    //src: starling/src/tags/menu/items/menu-item-link-to-selection.html
riot.tag2('menu-item-link-to-selection',
  '<i class="fa fa-link floating-menu_icon"></i> <span class="floating-menu_label">{label()}</span> <span class="floating-menu_shortcut">{shortcut}</span>',
  '',
  'class="{opts.classes} floating-menu_item" onclick="{linkToSelection}"', function(opts) {
'use strict';

var _util = require('lib/util.js');

var _eventTracking = require('lib/event-tracking');

var _eventTracking2 = _interopRequireDefault(_eventTracking);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var parent = this.parent;

var canvas = parent.opts.canvas;
var isMac = canvas.isMac;

this.label = function () {
  return parent.isBulkMenu ? 'Copy link to selection' : 'Copy link to card';
};
this.shortcut = isMac ? '⇧⌘L' : 'Ctrl+Shift+L';

this.linkToSelection = function () {
  if (parent.isBulkMenu) {
    var selectedNodes = canvas.getSelectedNodes();
    if (selectedNodes.length > 0) {
      var commaSeparatedIds = selectedNodes.map(function (n) {
        return n.id;
      }).join(',');
      var url = canvas.config.site_url + '/maps/' + canvas.access.publicIdentifier + '/edit/' + canvas.access.editKey + '?nodeid=' + commaSeparatedIds;
      window.history.pushState({}, "", url);
      (0, _util.copyToClipboard)({ text: url });
      canvas.notificationTag.show({ message: "Link copied to clipboard" });
      canvas.bulkActionsMenuTag.update();
      canvas.hidePopups();
      parent.hide();
    }
  } else if (parent.nodeTag) {
    var _url = canvas.config.site_url + '/maps/' + canvas.access.publicIdentifier + '/edit/' + canvas.access.editKey + '?nodeid=' + parent.nodeTag.id;
    window.history.pushState({}, "", _url);
    (0, _util.copyToClipboard)({ text: _url });
    canvas.notificationTag.show({ message: "Link copied to clipboard" });
    canvas.bulkActionsMenuTag.update();
    canvas.hidePopups();
    parent.hide();
  }

  _eventTracking2.default.track({
    category: (0, _util.getTrackingLabel)(parent),
    action: 'Link-To-Selection',
    label: 'Selection'
  });
};
});

    
  if (module.hot) {
    module.hot.accept()
    if (module.hot.data) {
      riot.reload('menu-item-link-to-selection')
    }
  }
  


//////////////////
// WEBPACK FOOTER
// ./starling/src/tags/menu/items/menu-item-link-to-selection.html
// module id = 700
// module chunks = 0